import { Component, Input } from '@angular/core';
import { StatusRecebimentoRegistro, StatusIntegracaoRegistro } from '../../../types/smartinteg';

@Component({
  selector: 'app-status-badge',
  template: `
    <p-tag [value]="status" [severity]="getSeverity()" [icon]="getIcon()"></p-tag>
  `
})
export class StatusBadgeComponent {
  @Input() status: string = '';

  getSeverity(): "success" | "secondary" | "info" | "warning" | "danger" | "contrast" | undefined {
    switch (this.status) {
      case StatusRecebimentoRegistro.CONCLUIDO:
      case StatusIntegracaoRegistro.INTEGRADO:
        return 'success';
      case StatusRecebimentoRegistro.PROCESSANDO:
        return 'info';
      case StatusRecebimentoRegistro.PENDENTE:
      case StatusIntegracaoRegistro.PENDENTE:
      case "PENDENTE":
        return 'warning';
      case StatusRecebimentoRegistro.ERRO:
      case StatusIntegracaoRegistro.ERRO:
        return 'danger';
      default:
        return 'secondary';
    }
  }

  getIcon(): string {
    switch (this.status) {
      case StatusRecebimentoRegistro.CONCLUIDO:
      case StatusIntegracaoRegistro.INTEGRADO:
        return 'pi pi-check-circle';
      case StatusRecebimentoRegistro.PROCESSANDO:
        return 'pi pi-spin pi-spinner';
      case StatusRecebimentoRegistro.PENDENTE:
      case StatusIntegracaoRegistro.PENDENTE:
        return 'pi pi-clock';
      case StatusRecebimentoRegistro.ERRO:
      case StatusIntegracaoRegistro.ERRO:
        return 'pi pi-exclamation-triangle';
      default:
        return 'pi pi-question-circle';
    }
  }
}
